module.exports = __webpack_public_path__ + "images/category_lp/macbook/assessment_achievements/4_3d371c5cdfc4470ff827d3f3fb02fcdf.png";